<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>{{$t('inseminatorStatistics')}}</h2>
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          @click="$router.push({ name: 'AddInsemi' })"
        >
          {{$t('inseminatorStatisticsInfo.addInseminatorInfo')}}
        </v-btn>
      </div>
      <!-------------------------- Tablet Screens -------------------------->
      <!-- start -->
      <v-card
        v-if="$vuetify.breakpoint.width <= 980"
        elevation="0"
        class="px-5"
        :loading="loading"
        :class="loading ? '' : 'py-1'"
      >
        <div class="d-flex mt-5">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            height="5px"
            :placeholder="$t('search')"
            dense
            v-model="search"
            @input="resetSearchOnEmpty"
            class="shrink"
          ></v-text-field>
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="searchInsemi"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="py-1 title">
            {{ from }} - {{ to }} {{$t('of')}} {{ totalitems }}
          </div>
          <v-btn
            :disabled="tabletTableOptions.page <= 1"
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            @click="tabletPageChange(false)"
          >
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            :disabled="tabletTableOptions.page >= totalPages"
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            @click="tabletPageChange(true)"
          >
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
        <v-card
          v-for="(item, index) in items"
          :key="item.inseminatorStatisticNo"
          class="inner-card my-4 py-2 px-4"
          :elevation="0"
          :style="
            index % 2 !== 0 && {
              backgroundColor: 'rgba(243, 243, 243, 0.5)',
            }
          "
          @click="goToInse(item.inseminatorStatisticNo)"
        >
          <v-row no-gutters class="my-5">
            <v-col md="12">
              <v-card-text style="color: #00bd73" class="py-"
                >{{$t('inseminatorStatisticsInfo.inseminatorNumber')}}</v-card-text
              >
              <v-card-text class="py-1 headline font-weight-bold">{{
                `#${item.inseminatorNumber}`
              }}</v-card-text>
            </v-col>
          </v-row>
          <v-row no-gutters class="my-5">
            <v-col md="4">
              <v-card-text style="color: #787878" class="py-1"
                >{{$t('dashboardS.inseminatorName')}}</v-card-text
              >
              <v-card-text class="py-1">{{ item.inseminatorName }}</v-card-text>
            </v-col>

            <v-col md="4">
              <v-card-text style="color: #787878" class="py-1"
                >{{$t('actionListmod.conceptionRate')}}</v-card-text
              >
              <v-card-text class="py-1">{{ item.conceptionRate }}</v-card-text>
            </v-col>

            <v-col md="4">
              <v-card-text style="color: #787878" class="py-1"
                >{{$t('actionListmod.dateOfmeasurement')}}</v-card-text
              >
              <v-card-text class="py-1">{{
                item.dateOfMeasurement 
              }}</v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
      <!------------------------ End -------------------------->
      <v-card v-else elevation="0" class="px-5">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            v-model="selected"
            item-key="inseminatorStatisticNo"
            :items-per-page="10"
            :loading="loading"
            :loading-text="$t('inseminatorStatisticsInfo.loadingInseminatorPleaseWait')"
            hide-default-footer
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': $t('farm.farmsPerPage'),
            }"
            :options.sync="tableOptions"
            :server-items-length="totalitems"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('inseminatorStatisticsInfo.searchByIDAndName')"
                  dense
                  v-model="search"
                  @click:append="searchInsemi"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchInsemi"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} {{$t('of')}} {{ totalitems }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.inseminatorStatisticNo"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  @click="goToInse(item.inseminatorStatisticNo)"
                  style="position: relative; width: 0; height: 0"
                >
                  <!-- <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td> -->
                  <td>{{ item.inseminatorNumber }}</td>
                  <td>{{ item.inseminatorName }}</td>
                  <td>{{ item.conceptionRate }}</td>
                  <td>{{ item.dateOfMeasurement | formatDate }}</td>
                  <div
                    style="position: absolute; right: 10px; top: 4px"
                    v-if="item === selectedItem"
                  >
                    <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        fab
                        v-bind="attrs"
                        v-on="on"
                        :to="({name: 'SingleFarm', params: { id: item.farmNumber }})"
                      >
                        <v-icon>mdi-dots-horizontal</v-icon></v-btn
                      >
                    </template>
                    <span>More Details</span>
                  </v-tooltip> -->
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          fab
                          v-bind="attrs"
                          v-on="on"
                          class="ml-1"
                          :to="{
                            name: 'EditFarm',
                            params: { id: item.farmNumber },
                          }"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip> -->
                  </div>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import InsemiService from "@/_services/InsemnatorService";

export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  watch: {
    tableOptions: {
      handler() {
        this.getInseminatorInfo();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBreakPoints) this.getTabletInseminatorInfo();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  async mounted() {
    document.title = this.$t('inseminatorStatistics');
    console.log("this ---> ", this.$t)
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    searchInsemi() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletInseminatorInfo();
      } else {
        this.tableOptions.page = 1;
        this.getInseminatorInfo();
      }
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletInseminatorInfo();
      } else {
        this.tableOptions.page = 1;
        this.getInseminatorInfo();
      }
    },
    getInseminatorInfo() {
      this.loading = true;
      InsemiService.getInseminatorInfo(this.tableOptions, this.search)
        .then((res) => {
          if (res.success) {
            this.items = res.data.inseminatorStatistic.rows;
            this.currentrows = res.data.inseminatorStatistic.num_rows;
            this.totalitems = res.data.inseminatorStatistic.total_rows;
            this.pageCount = Math.ceil(
              this.totalitems / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalitems / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage -
                res.data.inseminatorStatistic.num_rows);
            console.log(this.totalitems);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getTabletInseminatorInfo() {
      this.loading = true;
      InsemiService.getInseminatorInfo(this.tabletTableOptions, this.search)
        .then((res) => {
          if (res.success) {
            this.items = res.data.inseminatorStatistic.rows;
            this.currentrows = res.data.inseminatorStatistic.num_rows;
            this.totalitems = res.data.inseminatorStatistic.total_rows;
            this.pageCount = Math.ceil(
              this.totalitems / this.tabletTableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalitems / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage -
                res.data.inseminatorStatistic.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    goToInse(insemNUm) {
      this.$router.push({ name: "SingleInsemi", params: { id: insemNUm } });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.getInseminatorInfo();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletInseminatorInfo();
    },
  },
  data() {
    return {
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      search: "",
      selected: [],
      items: [],
      totalitems: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      loadingText: this.$t('loadingPleaseWait'),
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('inseminatorStatistics'),
          disabled: true,
          to: { name: "My farm" },
        },
      ],
      singleSelect: false,
      headers: [
        {
          text: this.$t('actionListmod.inseminatorId'),
          align: "start",
          value: "inseminatorNumber",
          class: "black--text",
        },
        {
          text: this.$t('dashboardS.inseminatorName'),
          value: "inseminatorName",
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.conceptionRate'),
          value: "conceptionRate",
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.dateOfmeasurement'),
          value: "dateOfMeasurement",
          class: "black--text",
          sortable: false,
        },
      ],
      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>